import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Depreciacao } from '../../../../types/Depreciacao.type';
import { Instancia } from '../../../../types/Instancia.type';

@Component({
  selector: 'app-depreciacao',
  templateUrl: './depreciacao.component.html',
  styleUrl: './depreciacao.component.css',
})
export class DepreciacaoComponent implements OnInit {
  depreciacoes: Depreciacao[] = [];
  loading: boolean = false
  loadingInteg: boolean = false
  date: Date | undefined;
  instancias: Instancia[] = [{id: 'VALE', nome: 'VALE'}, {id: 'UCP', nome: 'UCP'}, {id: 'UVP', nome: 'UVP'} ]
  instanciaSelecionada!: string

  constructor(
    private integradorService: IntegradorService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.carregar();
  }

  carregar() {
    this.loading = true;

    this.integradorService.getDepreciacoes().subscribe({
      next: (value) => {
        this.depreciacoes = value;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar as informações: " + error.error.message)
      },
      complete: () => {
        this.loading = false;
      }
    })

  }

  integrar(){
    
    if(this.date != undefined){
      this.loadingInteg = true

      let periodo = formatDate(this.date, 'MM/dd/yyyy', 'en-US')
      
      this.integradorService.postSolicitaDepreciacao(this.instanciaSelecionada, periodo).subscribe({
        next: (value) => {
          this.toastService.sucesso("Sucesso", "Integração realizada")
        },
        error: (err) => {
          this.toastService.erro("Erro", "Erro na solicitação: " + err.error.message)
        },
        complete: () => {
          this.loadingInteg = false
        }
      })
    }else{
      this.toastService.alerta("Período", "Selecione o período")
    }
      

  }
}
